// extracted by mini-css-extract-plugin
export default {"root":"style_root__0M3KC","controls":"style_controls__0zqVr","opponent":"style_opponent__kEeoK","inner":"style_inner__DP+KB","front":"style_front__X2R6u","back":"style_back__GZpXQ"};